import { useLazyQuery, useMutation } from '@apollo/client';
import { useEffect } from 'react';
import {
  createRequest,
  deleteRequest,
  updateDocStatus,
  updateRequest,
} from '../graphql/mutation';
import { getRequests } from '../graphql/query';

const useRequest = () => {
  const [getDeparts, catpData]: any = useLazyQuery(getRequests);

  const [addRequest] = useMutation(createRequest, {
    refetchQueries: [{ query: getRequests }],
  });
  const [editRequest] = useMutation(updateRequest, {
    refetchQueries: [{ query: getRequests }],
  });
  const [editDocStatus] = useMutation(updateDocStatus, {
    refetchQueries: [{ query: getRequests }],
  });
  const [removeRequest] = useMutation(deleteRequest, {
    refetchQueries: [{ query: getRequests }],
  });

  useEffect(() => {
    getDeparts();
  }, [getDeparts]);

  const requests = catpData?.data?.['getRequests']?.data || [];
  const refreshrequests = () => catpData?.refetch();
  return {
    requests,
    addRequest,
    editRequest,
    editDocStatus,
    removeRequest,
    refreshrequests,
    loading: catpData?.loading,
  };
};

export default useRequest;
